export default {"src":"/_next/static/media/close.74ae18c0.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};